import { axiosAjax} from '@app/src/config/axios';
import { HttpStatus } from '@app/src/utils/validations/constants';

export const serviceRecoverPassword = {
  async getData(values, url) {
    try {
      const { data } = await axiosAjax.post(url, values);
      if (data.data.code === HttpStatus.LOGIN_ERROR) {
        return data;
      }
      return data
    } catch (error) {
      throw error.response.data;
    }
  }
}
